import AmexEventsComponent from './AmexEventsComponent';

export default AmexEventsComponent;
